import React, { useState, useEffect } from 'react';
import "../styles/Partner.css";
import { useTranslation } from "react-i18next";
import { getPath, fetchPartnerData } from "../utils/functions";
import { useLocation, Link } from 'react-router-dom';

function PartnerSwiper() {
  const [t] = useTranslation();
  const location = useLocation();
  const [partnerSlides, setPartnerSlides] = useState([]);
  const [loading, setLoading] = useState(true);

  // 滑动方向
  const [direction, setDirection] = useState("left");

  useEffect(() => {
    let isMounted = true;
    const lang = location.pathname.startsWith('/hk') ? "zh-Hant-HK" : "en";

    const loadPartners = async () => {
      try {
        const data = await fetchPartnerData(lang);
        if (isMounted && data.length > 0) {
          const baseSlides = data.map(partner => ({ src: partner.image, name: partner.name }));
          const multipliedSlides = [];
          const rawCopies = 50;
          const copiesNeeded = Math.floor(rawCopies);

          for (let i = 0; i < copiesNeeded; i++) {
            multipliedSlides.push(...baseSlides);
          }

          setPartnerSlides(multipliedSlides);
        }
      } catch (error) {
        console.error('加载合作伙伴数据失败:', error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadPartners();
    return () => { isMounted = false; };
  }, [location.pathname]);

  // 切换滑动方向时重置动画
  const handleDirectionChange = (newDirection) => {
    setDirection(prev => {
      if (prev !== newDirection) {
        const track = document.getElementById('partner-swiper-1');
        if (track) {
          track.style.transition = 'none';
          track.style.transform = 'translateX(0)';
          setTimeout(() => {
            track.style.transition = 'all 0.8s ease';
          }, 10);
        }
      }
      return newDirection;
    });
  };

  if (loading) return null;

  return (
    <div className="partner-wrapper">
      <h2>{t('partner_swiper.title')}</h2>
      <div className="partner-swiper">
        <button
          className="partner-swiper-btn partner-swiper-btn-left"
          onClick={() => handleDirectionChange("left")}
        >
          &larr;
        </button>

        <button
          className="partner-swiper-btn partner-swiper-btn-right"
          onClick={() => handleDirectionChange("right")}
        >
          &rarr;
        </button>

        <div
          id="partner-swiper-1"
          className={`partner-track-${direction}`}
        >
          {partnerSlides.map((slide, index) => (
            <div key={`${index}-${slide.src}`} className="partner-slide">
              <Link to={getPath(`/partners/${slide.name.toLowerCase().split(" ").join("-")}`)}>
                <img
                  src={slide.src}
                  alt={slide.name}
                  loading="lazy"
                />
              </Link>
            </div>
          ))}
        </div>
      </div>

      <div className="view-all-container container text-center">
        <a href={getPath("/partners")} className="view-all-partner">
          {t('partner_swiper.view_more')}
        </a>
      </div>
    </div>
  );
}

export default PartnerSwiper;
